import axios from "axios";
import { HOST_API } from "src/config-global";

// ----------------------------------------------------------------------
const axiosInstance = axios.create({ baseURL: HOST_API });
axiosInstance.defaults.headers["Content-Type"] = "application/json";
axiosInstance.defaults.headers["Access-Control-Allow-Origin"] = "*";
// axiosInstance.interceptors.response.use(
//   (res) => res,
//   (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
// );

export default axiosInstance;
